"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextButton = exports.StyledPopup = exports.StyledButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Button = _interopRequireDefault(require("../../Button"));
var StyledPopup = exports.StyledPopup = (0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "styles__StyledPopup",
  componentId: "sc-1d9obgv-0"
})(["display:", ";align-items:center;justify-content:center;"], function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'flex' : 'none';
});
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1d9obgv-1"
})(["border-radius:21px;border:none;color:#007aff;cursor:pointer;font-size:14px;background:transparent;height:25px;line-height:24px;min-height:25px;min-width:25px;outline:0;overflow:visible;padding:0;position:relative;text-align:center;", " svg{z-index:2;display:block;margin:0 auto;position:relative;}*{outline:none;}span{display:block;margin-bottom:-7px;}"], function (p) {
  return p.isAction && "\n    padding: 0 5px;\n  ";
});
var StyledTextButton = exports.StyledTextButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__StyledTextButton",
  componentId: "sc-1d9obgv-2"
})(["border:none;outline:none;background:none;margin-left:10px;color:#007aff;cursor:pointer;font-family:'ONYOneFont','Helvetica',sans-serif;font-size:14px;"]);